
import React from "react";
import AdminLayout from "@/components/admin/AdminLayout";
import ProductAnalyticsDashboard from "@/components/admin/analytics/ProductAnalyticsDashboard";

const AdminProductAnalytics = () => {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Product Analytics</h1>
          <p className="text-muted-foreground mt-1">
            Comprehensive insights into product performance, sales trends, and inventory management
          </p>
        </div>

        <ProductAnalyticsDashboard />
      </div>
    </AdminLayout>
  );
};

export default AdminProductAnalytics;
